import React from 'react';
import { render } from '@testing-library/react';
import '@testing-library/jest-dom';
import userEvent from '@testing-library/user-event';
import { useFocusVisible } from './useFocusVisible';

const TestButton = ({ children, onFocus, onBlur }: any) => {
	const btnRef = React.useRef(null);
	const { isFocusVisible, focusFunction, blurFunction } = useFocusVisible(
		btnRef,
		onFocus,
		onBlur
	);
	return (
		<button
			className={isFocusVisible ? 'focus-visible' : ''}
			ref={btnRef}
			onBlur={blurFunction}
			onFocus={focusFunction}
		>
			{children}
		</button>
	);
};

describe('useFocusVisible', () => {
	const user = userEvent.setup();

	it('should have class focus-visible on Button on load', () => {
		const { container } = render(<TestButton />);
		const element = container.firstChild as HTMLElement;

		// expect that focus-visible class is added on initial load
		expect(element.classList.contains('focus-visible')).toBe(true);
	});

	it('should remove class focus-visible on mouse interaction', async () => {
		const { getByText } = render(<TestButton>Test Button</TestButton>);
		const element = getByText('Test Button');
		expect(element.classList.contains('focus-visible')).toBe(true);

		// click on the button and expect the class to be removed
		await user.click(getByText('Test Button'));
		expect(element.classList.contains('focus-visible')).toBe(false);
	});

	it('should reintroduce focus-visible class after first time', async () => {
		const { getByText } = render(
			<React.Fragment>
				<TestButton>Test Button 0</TestButton>
				<TestButton>Test Button 1</TestButton>
			</React.Fragment>
		);
		const firstBtn = getByText('Test Button 0');
		const secondBtn = getByText('Test Button 1');
		expect(firstBtn.classList.contains('focus-visible')).toBe(true);
		expect(secondBtn.classList.contains('focus-visible')).toBe(true);

		// click first button and expect the class to be removed
		await user.click(getByText('Test Button 0'));
		expect(firstBtn.classList.contains('focus-visible')).toBe(false);

		// tab and shift tab to refocus first button
		await user.tab();
		await user.tab({ shift: true });

		// expect that first button will get the class back
		expect(firstBtn.classList.contains('focus-visible')).toBe(true);
	});

	it('should call onFocus when focused', async () => {
		// const onFocus = console.log('working');
		const onFocus = jest.fn();
		render(<TestButton onFocus={onFocus}>Hello</TestButton>);

		await user.tab();
		await user.tab({ shift: true });
		expect(onFocus).toHaveBeenCalledTimes(1);
	});

	it('should call onFocus when focused', async () => {
		// const onFocus = console.log('working');
		const onBlur = jest.fn();
		render(<TestButton onBlur={onBlur}>Hello</TestButton>);

		await user.tab();
		expect(onBlur).toHaveBeenCalledTimes(1);
	});
});
